import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { ExpandableBlocks, ContentBlock } from 'components/ContentBlock'
import { ExpandableContext } from 'components/ContentBlock/components/ExpandableBlocksContainer'
import { Orders, Visible, Sale, Inventory } from './subPages'

const Availability = props => {
	const [t] = useTranslation()

	return(
		<ExpandableBlocks defaultExpandedId='4'>
			<ExpandableContext.Consumer>
				{({ expandedId }) => (
					<Fragment>
						<Sale {...props} blockId='0' expandedId={expandedId} />
						<Orders {...props} blockId='1' expandedId={expandedId} />
						<ContentBlock blockId='3' label={t('product_section.strings.visible')}>
							<Visible {...props}/>
						</ContentBlock>
						<ContentBlock blockId='4' label={t('product_section.strings.inventory_calculation')}>
							<Inventory {...props}/>
						</ContentBlock>
					</Fragment>
				)}
			</ExpandableContext.Consumer>
		</ExpandableBlocks>
	)
}

export default Availability
